
export const AUTHENTICATE_STATUS_OK = 20000;
export const AUTHENTICATE_STATUS_BAD_REQUEST = 40000;
export const AUTHENTICATE_STATUS_UNAUTHORIZED = 40001;
export const AUTHENTICATE_STATUS_NOT_CONFIRMED = 40002;
export const AUTHENTICATE_STATUS_FORBIDDEN = 40003;
export const AUTHENTICATE_STATUS_INVALID = 40004;
export const AUTHENTICATE_STATUS_NOT_EXIST = 40005;
export const AUTHENTICATE_STATUS_MISSING = 40006;
export const AUTHENTICATE_STATUS_ERROR = 50000;



// WEBPACK FOOTER //
// ./src/redux/authenticate/status.js